/***
 * check if a string is null, undefined or empty
 * @param value
 * return true if the string is null, undefined or empty
 */
export const isStringEmpty = (value?: string | null): boolean => {
  return value === undefined || value === null || value?.trim?.() === "";
};

export const isContainSubString = (value: string, other: string, trimSpaces = true, ignoreCase = true): boolean => {
  const { value1, value2 } = trimSpaces
    ? { value1: value?.trim(), value2: other?.trim() }
    : { value1: value, value2: other };
  return ignoreCase ? value1.toLowerCase().includes(value2.toLowerCase()) : value1.includes(value2);
};

export const classNames = (...args: (string | undefined)[]): string =>
  !args || args.length === 0
    ? ""
    : args
      .map((s) => s?.trim())
      .filter((s) => s)
      .join(" ")
      .trim();

